import { useEffect, useRef, useState } from 'react';
import useCurrencySymbol from 'app/utils/customHooks/useCurrencySymbol';
import { Accounts, AccountValue } from 'app/constants/types';
import { useLocation, useNavigate } from 'react-router-dom';
import logger from 'app/utils/logger';
import { useFilterChangeTransactions } from 'app/utils/services/transactionsService';
import { useTranslation } from 'react-i18next';

interface Props {
  accounts: Accounts[];
  selectedValue: AccountValue;
  changeSelectedValue: (data: AccountValue) => void;
  homePageFlag?: (flag: boolean) => void;
}

const useAccountsBox = (props: Props) => {
  const { t } = useTranslation();
  const { accounts, selectedValue, changeSelectedValue, homePageFlag } = props;
  const [account, setAccount] = useState([]);
  const [isOpenMenu, setIsOpenMenu] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const lang = location.pathname.substring(0, 3);

  const wrapperRef = useRef(null);

  useEffect(() => {
    function handleClickOutside(event: any) {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setIsOpenMenu(false);
      }
    }
    // Bind the event listener
    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [wrapperRef]);

  useEffect(() => {
    changeSelectedValue({
      value: accounts[0]?.iban,
      label: `${accounts[0]?.emp_title} (${accounts[0].iban})`,
      balance: accounts[0]?.main_balance,
      blocked: accounts[0]?.blocked_balance,
      name: accounts[0]?.emp_title,
      currency: accounts[0]?.currency,
      status: accounts[0]?.state,
      iban: accounts[0]?.iban,
      have_tax_order: accounts[0].have_tax_order,
      goverment_amount: accounts[0].goverment_amount,
    });
    const accountData = accounts.map((item) => {
      return {
        value: item.iban,
        label: `${item.emp_title} (${item.iban}) - ${item.main_balance} ${useCurrencySymbol(item.currency)}`,
        balance: item.main_balance,
        blocked: item.blocked_balance,
        name: item.emp_title,
        have_tax_order: item.have_tax_order,
        currency: item.currency,
        status: item.state,
        iban: item.iban,
        goverment_amount: item.goverment_amount,
      };
    });
    setAccount(accountData);
  }, []);

  const valueRef = useRef(selectedValue);
  valueRef.current = selectedValue;

  // const selectAllOption = {
  //   value: 'all',
  //   label: 'All selected',
  // };

  // const isSelectAllSelected = () => valueRef?.current.length === accounts.length;
  //
  // const isOptionSelected = (option: any) =>
  //   valueRef?.current.some(({ value }: any) => value === option.value) || isSelectAllSelected();

  // const getOptions = () => [selectAllOption, ...accounts];

  // const getValue = () => (isSelectAllSelected() ? [selectAllOption] : selectValue);

  const { isSuccessFilterTransactions, filterTransactionMutation, dataFilterTransactions } =
    useFilterChangeTransactions();

  const onChange = (newValue: any) => {
    changeSelectedValue({ ...newValue, label: `${newValue.name} (${newValue.iban})` });
    // filterTransactionMutation({ acc_no: newValue.iban });
    homePageFlag(false);

    // if (action === 'select-option' && option.value === selectAllOption.value) {
    //   setSelectValue(accounts);
    // } else if (
    //   (action === 'deselect-option' && option.value === selectAllOption.value) ||
    //   (action === 'remove-value' && removedValue.value === selectAllOption.value)
    // ) {
    //   setSelectValue([]);
    // } else if (actionMeta.action === 'deselect-option' && isSelectAllSelected()) {
    //   setSelectValue(accounts.filter(({ value }: any) => value !== option.value));
    // } else {
    //   setSelectValue(newValue || []);
    // }
  };

  const navigateToOrders = () => {
    navigate(`${lang}/payment-orders`);
  };

  const navigateToTransfer = () => {
    navigate(`${lang}/transfer-page`, { state: { selectedValue } });
  };

  return {
    t,
    account,
    isOpenMenu,
    wrapperRef,
    setIsOpenMenu,
    // isOptionSelected,
    // getOptions,
    // getValue,
    navigateToOrders,
    onChange,
    navigateToTransfer,
  };
};

export default useAccountsBox;
